<!--
登录
20241111
-->
<template>
  <div id="login_pagewrap"  style="display: flex;justify-content: center;">
    <div id="container">
      <div id="output"></div>
    </div>
    <div id="login_box">
      <div id="login_header">
        <router-link :to="{ path: '/' }">
          <div id="giantcolor"></div>
          <div id="giantlogo"></div>
          <div id="mmtlogo"></div>
          <div id="livlogo"></div>
        </router-link>
      </div>
      <div class="login_title">捷安特云盘系统(用户)</div>
      <div class="login_card">
        <div id="form_login">
          <div class="title">账号登录</div>

          <input type="text" ref="loginUsername" v-model="loginUsername" placeholder="手机号 / 邮箱" autocomplete="on" />

          <input type="password" ref="loginPassword" v-model="loginPassword" placeholder="密码" />

          <div class="btn_group">
            <el-button size="mini" type="primary" style="width: 100%;padding: 20px;font-size: 16px;"
              @click.stop="onLogin" :loading="loading" >
              <span style="color: #fff;">登录</span>
            </el-button>
          </div>
        </div>
      </div>
      <div class="login_bottom">捷安特（昆山）有限公司</div>
    </div>

    <!-- 申诉 1-->
    <el-dialog title="" :visible.sync="ssShow"  :width="'20%'" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false">
      <span slot="title">
        <div style="text-align: center;color: #383838;font-size: 16px;font-weight: 700;">
          账号异常
        </div>
      </span>
      <div style="display: flex;align-items: center;flex-direction: column;">
        <div style="color: #383838;font-size: 14px;font-size: 16px;">您的账户已冻结,</div>
        <div style="color: #383838;font-size: 14px;margin-top: 10px;font-size: 16px;">若要继续使用，请申诉!</div>
      </div>
      <!-- <span slot="footer"> -->
      <div style="display: flex;margin-top: 30px;">
        <el-button type="" style="width: 50%;" @click="ssShow = false">
          <span style="color: #383838;">取消</span>
        </el-button>
        <el-button type="primary" style="width: 50%;" @click="addss">
          <span style="color: #fff;">申诉</span>
        </el-button>
      </div>
      <!-- </span> -->
    </el-dialog>

    <!-- 申诉 2-->
    <el-dialog title="" :visible.sync="moveShow"  :width="'20%'" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <span slot="title">
        <div style="text-align: center;color: #383838;font-size: 16px;font-weight: 700;">
          账号申诉
        </div>
      </span>
      <el-input type="textarea" placeholder="请输入内容" v-model="textarea" maxlength="30" show-word-limit
        :autosize="{ minRows: 8, maxRows: 4 }">
      </el-input>
      <div style="color: #383838;font-size: 14px;margin-top: 10px;">温馨提示：</div>
      <div style="color: #383838;font-size: 14px;margin-top: 10px;">若账户半年内未登录，将会被系统冻结，为避免账户异常，请保持一定的登录频率。</div>
      <span slot="footer">
        <el-button type="primary" round style="width: 100%;" @click="addshenshu">
          <span style="color: #fff;">提交</span>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { login, unlock } from '@/api/login/index.js'
import md5 from "js-md5"
import { Victor } from "../assets/js/vector"
export default {
  name: "Login",
  components: {},
  props: {},
  data() {
    return {
      //用户名、密码
      loginUsername: "",
      loginPassword: "",
      //
      loading: false,

      // 申诉弹框
      ssShow: false,
      moveShow: false,
      textarea: ''
    }
  },
  computed: {},
  watch: {},
  created() {
    const _this = this
  },
  mounted() { 
    const _this = this
    //登录特效
    // 添加resize事件监听
    //window.addEventListener('resize', _this.updateWindowSize);
    // 初始调用
    _this.updateWindowSize();
  },
  destroyed() { },
  methods: {
   updateWindowSize() {
      const _this = this;
      const width = window.innerWidth || document.documentElement.clientWidth;
      console.log('当前窗口宽度:', width, 'px');
      if (width > 640) {
        _this.$nextTick(function () {
          var victor = new Victor("container", "output")
          victor(["#1A38FF", "#4E66FF"]).set()
        })
      } else { 
        
        // let dom = querySelector('#container')
        // dom.style.backgroundColor = '#fff'
      }
      return width;
      // 在这里添加你的响应式逻辑
    },
    onLogin() {
      const _this = this
      _this.loading = true
      //提交
      login({
        userName: _this.loginUsername,
        passWord: md5(_this.loginPassword)
      })
        .then(res => {
          if (res.status == 1) {
            _this.loading = false
            document.cookie = res.data   // 非跨域传递cookie 直接设置cookie即可
            localStorage.setItem("user_token", res.data)
            _this.$router.push({ path: "/main" })
            _this.$message.success(`登录成功`)
          } else if (res.status == -3) {
            _this.loading = false
            _this.ssShow = true
          } else { 
            _this.loading = false
            _this.$message.error(res.msg);
          }
        })
        .catch(err => {
          _this.loading = false
        })

    },
    addss() { 
        const _this = this
        _this.ssShow = false
        _this.textarea = ''
        _this.moveShow = true
    },
    // 申诉提交
    addshenshu() {
      const _this = this
      unlock({
        userName: _this.loginUsername,
        message: _this.textarea
      })
        .then(res => {
          if (res.status == 1) {
             _this.textarea = ''
            _this.moveShow = false
          } else {
            _this.$message.warning(res.msg)
          }
        })
        .catch(err => {
          _this.loading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
@import "./login.less";

/* 考虑安全区域 */
body {
  transition: all 0.3s !important;
}

#container {
  position: fixed;
  height: 100%;
  width: 100%;
  min-height: 100vh;
  z-index: 0;
}

#login_box {
  width: 90%;
  max-width: 360px;
  margin-top: 25vh;
  position: fixed;
  background-color: #fff;
  padding: 20px 30px 50px;
  display: inline-block;
  min-height: 430px;
  z-index: 1;
  text-align: left;
  border-radius: 10px;

  .login_title {
    margin: 10px 0 20px;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
  }

  .login_bottom {
    text-align: center;
    color: #888;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  }
}
// 
@media (min-width: 1150px) {
    #login_box {
        width: 90%;
        max-width: 360px;
        margin-top: 25vh;
        position: fixed;
        background-color: #fff;
        padding: 20px 30px 50px;
        display: inline-block;
        min-height: 430px;
        z-index: 1;
        text-align: left;
        border-radius: 10px;
    }
}


@media (max-width: 800px) {
   #login_box {
        width: 90%;
        max-width: 360px;
        margin-top: 25%;
        position: fixed;
        background-color: #fff;
        padding: 20px 30px 50px;
        display: inline-block;
        min-height: 430px;
        z-index: 1;
        text-align: left;
        border-radius: 10px;
        box-shadow: 0 0 10px rgba(0,0,0,0.2);
    }
    
    #container{
      background: #4E66FF !important;
    }
}

@media (max-width: 640px) {
   #login_box {
        width: 90%;
        max-width: 360px;
        margin-top: 39%;
        position: fixed;
        background-color: #fff;
        padding: 20px 30px 50px;
        display: inline-block;
        min-height: 430px;
        z-index: 1;
        text-align: left;
        border-radius: 10px;
        box-shadow: 0 0 10px rgba(0,0,0,0.2);
    }

    #container{
      background: #4E66FF !important;
    }
}


@media (max-width: 400px) {
   #login_box {
        width: 90%;
        max-width: 360px;
        margin-top: 28%;
        position: fixed;
        background-color: #fff;
        padding: 20px 30px 50px;
        display: inline-block;
        min-height: 430px;
        z-index: 1;
        text-align: left;
        border-radius: 10px;
        box-shadow: 0 0 10px rgba(0,0,0,0.2);
    }

    #container{
      background: #4E66FF !important;
    }
}


</style>
